export const getNormalizedName = (name: string) => {
  const isChrome = /Chrome/.test(navigator.userAgent);
  if (isChrome) {
    return name.replace(/[\u{1d41a}-\u{1d433}]+/gu, (s) => s.normalize('NFKD'));
  }

  return name;
};
